export default "__VITE_ASSET__GloI2sLP__"